/** Le date arrivano dall'API come testo ISO (o Date): ritorna un Date valido oppure null. */
function toDate(value: unknown): Date | null {
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  if (typeof value === 'string' && value) {
    const d = new Date(value);
    return Number.isNaN(d.getTime()) ? null : d;
  }
  return null;
}

/** Converte una data ISO (o assente) in "YYYY-MM-DD" per un <input type="date">.
 * Usa i componenti data LOCALI (non toISOString/UTC): fromDateInputValue costruisce la
 * mezzanotte locale, quindi l'estrazione deve leggere lo stesso fuso — altrimenti con
 * fusi avanti su UTC (es. CEST) ogni giro modifica→salva perde un giorno (bug reale
 * trovato il 15/9/2026 testando dal vivo il flusso di modifica). */
export function toDateInputValue(value: unknown): string {
  const d = toDate(value);
  if (!d) return '';
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

/** Converte "YYYY-MM-DD" in data ISO (mezzanotte locale), o null se vuoto. */
export function fromDateInputValue(value: string): string | null {
  if (!value) return null;
  return new Date(`${value}T00:00:00`).toISOString();
}

/** Formato leggibile it-CH per la UI (card/pannello). */
export function formatDate(value: unknown): string | null {
  const d = toDate(value);
  return d ? d.toLocaleDateString('it-CH') : null;
}

/** Vero se la scadenza è STRETTAMENTE prima di oggi (mezzanotte locale) — una
 * scadenza fissata per "oggi" non è ancora in ritardo, lo diventa da domani. */
export function isOverdue(value: unknown, now: Date = new Date()): boolean {
  const d = toDate(value);
  if (!d) return false;
  const startOfToday = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  return d < startOfToday;
}

/** Vero se la scadenza cade nel giorno di calendario odierno (né ieri né domani). */
export function isDueToday(value: unknown, now: Date = new Date()): boolean {
  const due = toDate(value);
  if (!due) return false;
  return due.getFullYear() === now.getFullYear() && due.getMonth() === now.getMonth() && due.getDate() === now.getDate();
}
